import { ChangeEvent, FC, useState } from 'react';
import { FAIcon } from '@nextgen-web-framework/all';
import ImageAndTextContainer from '../ImageAndTextContainer/ImageAndTextContainer';
import { CMSTransformerDataType } from '../../cms/types/common';
import { transformImageAndText, transformTextOnly } from '../../cms/component-transformers';
import { ComponentType } from '../../cms/registries/types/propTypes';
import TextOnlyContainer from '../TextOnly/TextOnly';
import type { AccordionComponentProptype } from './types/propsTypes';
import styles from './AccordionComponent.module.scss';

const AccordionComponent: FC<AccordionComponentProptype> = (props: AccordionComponentProptype) => {
  const { accordionItemArr, sectionTitle } = props;
  const baseID = `cms-accordion-component-${sectionTitle}`;
  const [activeAccordionId, setActiveAccordionId] = useState<string>();
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { id, checked },
    } = e;
    setTimeout(() => {
      const sectionElement = document.querySelector(`label[for="${id}"]`)?.closest('section');
      sectionElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
    setActiveAccordionId(checked ? id : '');
  };
  return (
    <>
      {sectionTitle && <h3 className={styles['cms-accordion-section-title']}>{sectionTitle}</h3>}
      {accordionItemArr.map(({ accordion_title, collapsed_content_section, ...restItem }, index) => {
        let ContentComponent: React.ElementType = ImageAndTextContainer,
          contentTransformer: (data: CMSTransformerDataType) => {} = transformImageAndText;
        if (collapsed_content_section === ComponentType.text_only) {
          ContentComponent = TextOnlyContainer;
          contentTransformer = transformTextOnly;
        }
        return (
          <section
            className={styles['cms-accordion-component']}
            id={`section-${baseID}-${index}-${accordion_title}`}
            key={accordion_title}
          >
            <input
              type="checkbox"
              id={`${baseID}-${index}-${accordion_title}`}
              className={styles['accordion-toggle']}
              name={`cms-accordion-item-${accordion_title}`}
              checked={activeAccordionId === `${baseID}-${index}-${accordion_title}`}
              onChange={handleChange}
            />
            <label
              htmlFor={`${baseID}-${index}-${accordion_title}`}
              className={styles['accordion-header']}
              data-testid={`testid-${index}`}
            >
              <h4 className={styles['accordion-title']}>{accordion_title}</h4>
              <FAIcon iconName="chevron-down" className={styles['icon']} />
            </label>
            <div role="contentinfo" className={styles['accordion-content-body']}>
              <ContentComponent {...contentTransformer(restItem)} />
            </div>
          </section>
        );
      })}
    </>
  );
};
export type { AccordionComponentProptype };
export default AccordionComponent;
